import { render, staticRenderFns } from "./RegraCampoEditor.vue?vue&type=template&id=c7ce245c&scoped=true"
import script from "./RegraCampoEditor.vue?vue&type=script&lang=js"
export * from "./RegraCampoEditor.vue?vue&type=script&lang=js"
import style0 from "./RegraCampoEditor.vue?vue&type=style&index=0&id=c7ce245c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ce245c",
  null
  
)

export default component.exports